import React from 'react'
import { DevPanelData } from '../types'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import CheckboxInput from 'LuxKit/Checkbox/CheckboxInput'
import { usePseudoloc } from 'i18n/PseudolocContext'

interface Props {
  state: DevPanelData
}

function I18nTab(_props: Props) {
  const { enabled, toggle } = usePseudoloc()

  return <Pane padding={20}>
    <VerticalSpacer gap={16}>
      <Heading variant="heading5">Internationalization</Heading>

      <VerticalSpacer gap={12}>
        <CheckboxInput
          checked={enabled}
          onChange={(e) => {
            if (e.target.checked !== enabled) {
              toggle()
            }
          }}
        >
          Enable Pseudolocalization
        </CheckboxInput>
        <BodyText variant="small" colour="neutral-two">
          Pseudolocalization transforms all text to help identify untranslated strings and test UI layout with longer text.
        </BodyText>
      </VerticalSpacer>

      <MessageBanner kind="informational-primary">
        <BodyText variant="small">
          <b>Pseudoloc</b> adds brackets around text and replaces characters with accented versions to simulate translated content.
          This helps identify:
        </BodyText>
        <ul style={{ marginTop: '8px', marginBottom: 0, paddingLeft: '20px' }}>
          <li>Untranslated strings (they won't have brackets)</li>
          <li>UI layout issues with longer text</li>
          <li>Hardcoded strings that bypass i18n</li>
        </ul>
      </MessageBanner>
    </VerticalSpacer>
  </Pane>
}

export default I18nTab
